import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App.tsx";
import { ErrorApi } from "./api/cliente.ts";
import { ProveedorSesion } from "./sesion/ContextoSesion.tsx";
import "./estilos.css";

const cache = new QueryClient({
  defaultOptions: {
    queries: {
      // Un 401 ya lo resolvió (o no) el cliente refrescando; un 403 no mejora
      // por insistir. Reintentar solo tiene sentido ante fallos de red.
      retry: (intentos, error) => !(error instanceof ErrorApi) && intentos < 2,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: { retry: false },
  },
});

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("Falta #raiz en index.html.");

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cache}>
      <BrowserRouter>
        <ProveedorSesion>
          <App />
        </ProveedorSesion>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
